/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useUserContext} from "../../../contexts/userContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as CreateTeamSvg } from '../../../resources/images/people-dark-large.svg';

/* Styles */
import styles from "./styles";


const EditTeamModal = ({showEditTeamModal, setShowEditTeamModal, setShowDeleteTeamModal, setShowDeleteDefaultTeamModal, isDefault, teamName, teamId, editTeam}) => {
  
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId
  const [sameGroupName, setSameGroupName] = useState(false)

  useEffect(() => {
    if (!showEditTeamModal) {
      setSameGroupName(false)
    }
  }, [showEditTeamModal]);

  const handleEditTeam = async (values) => {
    const response = await editTeam(values)
    if (response.success) {
      setShowEditTeamModal(false)
    } else if (response.errorMessages[0].code === "420"){
      setSameGroupName(true)
    }
  }

  return (
      <UCModal
        className={classes.editTeamModal}
        showModal={ showEditTeamModal }
        setShowModal={ setShowEditTeamModal }
        modalIcon={ <CreateTeamSvg /> }
        modalTitle={ <FormattedMessage id="editTeam.title" values={{teamName: teamName}}/> }
        modalDescription={ <FormattedMessage id="editTeam.description"/> }
        modalContent={
        <Content
          teamName={ teamName }
          setShowModal={ setShowEditTeamModal }
          handleEditTeam={handleEditTeam}
          setShowDeleteTeamModal={setShowDeleteTeamModal}
          setShowDeleteDefaultTeamModal={setShowDeleteDefaultTeamModal}
          isDefault={isDefault}
          teamId={teamId}
          companyEntityId={companyEntityId}
          sameGroupName={sameGroupName}
          setSameGroupName={setSameGroupName}
        /> }
        dataTestId="editTeamModal"
      />
  )
}

export default EditTeamModal;
